<template>
  <div class="boox-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("router.updateApply") }}</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'applyAdd' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">

        <el-table :data="tableData"
                  :header-cell-style="tableHeaderColor"
                  :height="tableHeight"
                  style="width: 100%;height: 100%;overflow-y: scroll;">
          <el-table-column
                  type="index"
                  align="center"
                  fixed="left"
                  label="序号"
                  :key="Math.random()"
                  width="50"
          >
            <template slot-scope="scope">
          <span v-if="!!params.page">{{
            (params.page - 1) * params.limit + scope.$index + 1
          }}</span>
              <span v-else>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  prop="title"
                  align="center"
                  show-overflow-tooltip
                  label="标题">
          </el-table-column>
          <el-table-column
                  prop="updatedAt"
                  align="center"
                  label="日期">
            <template slot-scope="scope">
              <span>{{scope.row.updatedAt | filterDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
                  prop="updatedAt"
                  align="center"
                  label="发布状态">
            <template slot-scope="scope">
              <span v-if="scope.row.public===0">未发布</span>
              <span v-if="scope.row.public===1" class="green">已发布</span>
            </template>
          </el-table-column>
          <el-table-column
                  fixed="right"
                  label="管理"
                  align="center">
            <template slot-scope="scope">
              <!--<span @click="toView(scope.row._id)" class="checkDetailsBtn">查看详情</span>-->
              <span @click="toEdit(scope.row._id)" class="checkDetailsBtn">编辑</span>
              <span @click="toPublic(scope.row._id)" class="checkDetailsBtn">发布</span>
              <span @click="toDel(scope.row._id)" class="delBtn">删除</span>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="pageNum"
      />
    </el-card>

    <el-dialog
      title="软件详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="booxItem">
        <div class="boox-dialog-item">
          <p>标题</p>
          <p>{{ booxItem.title }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>版本</p>
          <p>{{ booxItem.version }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>类型</p>
          <p>{{ booxItem.type }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>语言</p>
          <p>{{ booxItem.lang }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>区域</p>
          <p>{{ booxItem.region }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>文件</p>
          <p>{{ booxItem.file.name }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>备注</p>
          <p>{{ booxItem.comment }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>简介</p>
          <el-input
            v-model="booxItem.description"
            disabled
            type="textarea"
            :rows="2"
            resize="nuno"
            style="width: 100%"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
  </div>
</template>

<script>
import DelPopup from "@/components/delPopup";
import Pagination from "@/components/pagination";
export default {
  components: {
    DelPopup,
    Pagination
  },
  computed: {
    delPopup:  {
      get: function () {
        return this.$store.state.popup.delPopup
      },
      set: function (newValue) {
        this.$store.state.popup.delPopup = newValue
        this.$store.state.popup.appModal = newValue
      }
    },
    tableHeight ()  {
      return window.innerHeight-250
    },
  },
  watch: {
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, select: 'title updatedAt public', sortBy: "createdAt", version: "joinTest" },
      booxItem: null,
      centerDialogVisible: false,
      updateId: '',
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 表格操作按钮
    tableHandle(type) {
      if (type === 'del') {
        this.$http.delUpdate(this.updateId).then(res => {
          this.updateId = ''
          this.delPopup = false
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        });
      }
    },
    //  确认删除
    deleteHandle() {
      this.$store.commit("windowHandle", "delPopup");
      this.tableHandle('del');
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },
    getList() {
      this.$http.getUpdateList(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count
      });
    },
    toEdit(id) {
      this.$router.push({ name: "applyAdd", query: { id: id } });
    },
    toDel(id) {
      this.updateId = id
      this.delPopup = true
    },
    toPublic (id) {
      this.$http.publicUpdate({id: id, data: {id: id, public: 1}}).then(res => {
        this.getList();
        this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
      });
    },
    toView(id) {
      // this.booxItem = data.row;
      // this.centerDialogVisible = !this.centerDialogVisible;
      this.$router.push({ name: "updateView", query: { id: id } });
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.boox-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
}
</style>
